import commonDataAccess from "../commonDataAccess";
import { IFilter } from "src/@redux/listRedux";

class VisitorDataAccess {
  getList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData("visitor/getall", parameters);
  };
  deleteVisitor = (visitorIds: string) => {
    return commonDataAccess.deleteData(`Visitor/delete`, { ids: visitorIds });
  };
  getVisitorInfo = async (visitorId) => {
    var result = await commonDataAccess.getData(`Visitor/get/visitorInfo`, {
      id: visitorId,
    });

    return result;
  };
  getVisitorNamesDropdown = () => {
    return commonDataAccess.getData("Visitor/dropdown/visitorName");
  };
  getCompanyNamesDropdown = () => {
    return commonDataAccess.getData("Visitor/dropdown/companyName");
  };
  saveVisitorInfo = async (data: any) => {
    var result = await commonDataAccess.postData(
      "Visitor/save/visitorInfo",
      data,
    );
    return result;
  };
  getVisitorLogList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return commonDataAccess.getData("visitor/getall/visitorlog", parameters);
  };
  getCompletedVisitorList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
    type: string;
  }) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      type: params.type,
      ..._filters,
    };
    return commonDataAccess.getData("visitor/getall/completedvisitorlog", parameters);
  };

  getVisitorJobDetailById = (id: number) => {
    return commonDataAccess.getData("visitor/get/visitorJobDetail", {
      id,
    });
  }

  saveHostComments = (id: number, comments: string) => {
  return commonDataAccess.postData("visitor/save/hostComments", { id, comments });
};
}
export default new VisitorDataAccess();
